import { navStack, resetTo } from '../store.js';
import { __ } from '../i18n.js';
import Icon from './Icon.jsx';

/**
 * HH-1: five tabs (ETM-HUB-BUILD-BRIEF.md "Defaults adopted" #1) — the MD3
 * maximum, and the ceiling: nothing else ever gets a tab.
 *
 * `name` is the screen resetTo() lands on; `match` is the set of screens
 * that light the tab up. The whole category→time→task flow keeps
 * highlighting Vandaag exactly as it did when this tab was called "Start"
 * (the WP-3 match-array pattern), so no pre-existing flow changes what the
 * user sees in the nav.
 *
 * Subscriptions/stats/household live under Meer rather than earning a tab:
 * they're consulted monthly, not daily (plan §3.1).
 */
const GROUPS = [
  { name: 'home', icon: 'today', match: ['home', 'category', 'time', 'task', 'skip'], label: () => __('Vandaag', 'etm') },
  { name: 'week', icon: 'calendar_month', match: ['week', 'scheduleForm'], label: () => __('Week', 'etm') },
  { name: 'lists', icon: 'format_list_bulleted', match: ['lists', 'listDetail'], label: () => __('Boodschappen', 'etm') },
  { name: 'manage', icon: 'checklist', match: ['manage', 'taskForm', 'project', 'projectForm'], label: () => __('Taken', 'etm') },
  { name: 'settings', icon: 'more_horiz', match: ['settings', 'stats', 'household', 'subscriptions', 'subscriptionForm'], label: () => __('Meer', 'etm') },
];

/** MD3 navigation bar: outlined icon at rest, filled icon in an active-indicator pill. */
export default function BottomNav() {
  const active = navStack.value[navStack.value.length - 1]?.name;
  return (
    <nav class="etm-bottom-nav">
      {GROUPS.map((group) => {
        const isActive = group.match.includes(active);
        return (
          <button
            key={group.name}
            type="button"
            class={`etm-nav-btn${isActive ? ' active' : ''}`}
            onClick={() => resetTo(group.name)}
          >
            <span class="etm-nav-btn__indicator">
              <Icon name={group.icon} fill={isActive} size={24} />
            </span>
            <span class="etm-nav-btn__label">{group.label()}</span>
          </button>
        );
      })}
    </nav>
  );
}
